import { render, staticRenderFns } from "./TabThreeContent.vue?vue&type=template&id=906257fa&scoped=true"
import script from "./TabThreeContent.vue?vue&type=script&lang=js"
export * from "./TabThreeContent.vue?vue&type=script&lang=js"
import style0 from "./TabThreeContent.vue?vue&type=style&index=0&id=906257fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906257fa",
  null
  
)

export default component.exports